import React from 'react';
import {getItems} from '../../services/api/apiBox';
import Loading from '../../components/Loading/Loading';
import BoxItemList from '../Box/BoxItemList';

class BoxDetailsPage extends React.Component {
    state = {
        items: [],
        loading: true
    };

    componentDidMount() {
        this.fetchItems();
    }

    fetchItems = async () => {
        try {
            const {match} = this.props;
            const {params} = Object.assign({}, match);
            const {box_id} = Object.assign({}, params);

            if (isNaN(box_id)) throw new Error('ID thùng không đúng.');

            const {data: dataRes} = await getItems(box_id);
            const {success, data, message} = Object.assign({}, dataRes);
            if (!success) throw new Error(message);

            this.setState({items: data, loading: false});
        } catch (e) {
            alert(e.message);
            this.setState({loading: false});
        }
    };

    render() {
        const {items, loading} = this.state;
        const {match} = this.props;
        const {params} = Object.assign({}, match);
        const {box_id} = Object.assign({}, params);

        if (loading) return <Loading/>;

        return (
            <div className="BoxDetailsPage">
                <BoxItemList items={items} boxId={box_id}/>
            </div>
        );
    }
}

export default BoxDetailsPage;
